import { HttpClient } from '../utils/httpClient';

const PATH = {
    getData: '/client/data/event/dashboard',
};

const getEventsData = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getData}`, { params }).then(callback).catch(error).finally(next);
};

export const DashboardService = {
    getEventsData,
};
